import {
  AccountNonce,
  Address,
  Ether,
  L2ChainId,
  L2Signature,
  TokenId,
  TokenSymbol,
} from 'types'
import {
  ChangePubKeyCREATE2,
  ChangePubKeyECDSA,
  ChangePubKeyOnchain,
} from 'utils/signer/transactions/changePubKey'
import { TxEthSignature } from 'utils/signer/types'
import { ApiV1Response, http } from './http'

export interface PostChangePubKeyBody {
  currency: TokenSymbol // 'BTC'
  chainId: L2ChainId
  newPkHash: Address
  fee: Ether // '0.001'
  feeToken: TokenId // 140
  nonce: AccountNonce // 0
  ts: number // 1684419923
  pubKey: string // Layer2 Public Key
  signature: L2Signature
  ethAuthData:
    | ChangePubKeyOnchain
    | ChangePubKeyECDSA
    | ChangePubKeyCREATE2
    | undefined
  ethSignature: TxEthSignature | undefined

  // Referral code
  inviteCode?: string
}

export async function postChangePubKey<T extends ApiV1Response>(
  accountId: number,
  data: PostChangePubKeyBody,
): Promise<T> {
  return await http
    .post<T>(`/account/${accountId}/changePubKey`, data)
    .then((r) => r.data)
}
